/*
 * @Author: your name
 * @Date: 2021-10-11 11:44:01
 * @LastEditTime: 2021-11-15 15:29:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mrc\src\service\api\staffType.js
 */
//静态资源
import http from '../httpConfig'

const table = "mrbase_sys_static_resource"

// 静态资源列表
export const static_resource_list = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('api/static-resource/list/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 新增静态资源
export const static_resource_add = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('api/static-resource/add/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 修改静态资源
export const static_resource_edit = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('api/static-resource/update/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 查询静态资源详情
export const static_resource_detail = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/static-resource/find/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 删除静态资源
export const static_resource_delete = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/static-resource/delete/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

